import Component from '../site/Component';

/**
 * Component for autocomplete input
 */
export default class Autocomplete extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    /* eslint-disable no-underscore-dangle */
    this.initializeAutocomplete(this.$element);

    // Add observer to look for dynamically added search bars like EDC
    const observer = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches('.autocomplete-input')) {
              this.initializeAutocomplete($(node));
            } else if (node.nodeType === 1 && node.querySelectorAll) {
              node.querySelectorAll('.autocomplete-input').forEach(childNode => {
                this.initializeAutocomplete($(childNode));
              });
            }
          });
        }
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    /* eslint-enable no-underscore-dangle */
  }

  initializeAutocomplete($element) {
    if ($element.length) {
      $element.each((index, element) => {
        const $elementInstance = $(element);
        $elementInstance.autocomplete({
          minLength: 2,
          source: (request, response) => {
            const term = encodeURIComponent(request.term).replace(/%20/g, '+');
            $.getJSON(
              `/wp-json/hachette/v1/suggest/${term}`,
              (data) => {
                // Only show titles if this is the EDC title lookup
                if ($elementInstance.hasClass('edc-title-lookup')) {
                  const today = new Date().toISOString().split('T')[0];
                  const filteredData = data.filter(
                    item => item._source.post_type === 'hbg-title' &&
                    (item._source.format === 'BB' || item._source.format === 'BC' ) &&
                    item._source.pub_date <= today
                  );
                  response(filteredData);
                } else {
                  response(data);
                }
              }
            );
          },
          select: (event, ui) => {
            // For EDC lookup show book data on the same page
            if ($elementInstance.hasClass('edc-title-lookup')) {
              this.addItemToPage(ui.item, $elementInstance);
            } else {
              // Redirect
              $elementInstance.val('');
              window.location.href = ui.item._source.permalink;
            }
            return false;
          },
          focus: () => false,
        })
          .autocomplete('instance')
          ._renderItem = (ul, item) => {
            const icon = window.icons[item._source.post_type] || '';

            return $('<li>')
              .append(
                $('<a>')
                  .attr('href', item._source.permalink)
                  .attr('onclick', 'event.preventDefault()')
                  .text(item.text)
                  .prepend(
                    $('<img alt="" />').attr('src', icon),
                  ),
              )
              .appendTo(ul);
          };
      });
    }
  }

  /**
   * Add the selected item to the current page
   * @param {Object} item - The selected item from the autocomplete suggestions
   * @param {Object} $element - The current input element
   */
  addItemToPage(item, $element) {
    const regex = /\/titles\/([^\/]+)\/([^\/]+)\/([^\/]+)\//;
    const match = item._source.permalink.match(regex);
    if (match) {
      let [, author, bookTitle, isbn13] = match;

      const bookSection = $element.closest('.edc-form-single-book-section');
      // Set the section values to the corresponding inputs
      bookSection.find('input[name="isbn"]').val(isbn13.replace(/-/g, ' '));
      bookSection.find('input[name="title"]').val(item.text.replace(/-/g, ' '));
      bookSection.find('input[name="author"]').val(author.replace(/-/g, ' '));
      const $labels = bookSection.find('.edc-book-label-hidden');
      // Remove the class 'edc-book-label-hidden' from each of these elements
      $labels.each(function() {
          $(this).removeClass('edc-book-label-hidden');
      });
    }
  }
}
